/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Payment_DateInputs */

const vi_report_debt_payment_date = /** @type {(inputs: Report_Debt_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày`)
};

/**

* @param {Report_Debt_Payment_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_payment_date = /** @type {((inputs?: Report_Debt_Payment_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Payment_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_payment_date(inputs)
});